import * as Marzipano from "marzipano"
import { viewer } from "../data-config"

const arrowOpacity = {
    hovered: 0.7,
    unhovered: 0.1,
    idle: 0.3,
}

export function setupNavigationArrows() {
    const arrowsContainer = document.getElementById('pano-arrows')
    const arrows = arrowsContainer.getElementsByClassName('arrow')

    for (var i = 0; i < arrows.length; i++) {
        arrows[i].style.opacity = arrowOpacity.idle
        arrows[i].addEventListener('mouseenter', onEnter)
        arrows[i].addEventListener('mouseleave', onLeave)
        arrows[i].addEventListener('touchstart', onEnter)
        arrows[i].addEventListener('touchend', onLeave)
    }

    function onEnter() {
        const direction = this.classList[1].split('-')[1]
        const autorotate = Marzipano.autorotate({
            yawSpeed: direction == 'left' ? -0.2 : direction == 'right' ? .2 : 0,
            pitchSpeed: direction == 'down' ? -0.2 : direction == 'up' ? .2 : 0,
            yawAccel: 2,
            pitchAccel: 2,
            targetFov: null,
        })
        viewer.startMovement(autorotate)

        for (var j = 0; j < arrows.length; j++) {
            if (arrows[j] != this) {
                arrows[j].style.opacity = arrowOpacity.unhovered
            } else {
                arrows[j].style.opacity = arrowOpacity.hovered
            }
        }
    }

    function onLeave() {
        viewer.stopMovement()
        for (var j = 0; j < arrows.length; j++) {
            arrows[j].style.opacity = arrowOpacity.idle
        }
    }
}
